import { ChangeDetectionStrategy, Component } from '@angular/core'
import { StatusContext } from 'src/app/account/components/app-resources-view/app-resources-view.component'
import { BannerScenario, buildBannerScenarios } from '../../mocks/showcase-banner-mocks'
import {
  RECOVERY_SCREEN_TABS,
  RecoveryScreenScenario,
  buildRecoveryScreenScenarios,
} from '../../mocks/showcase-recovery-screen-mocks'

/**
 * App-wide banner previews. The picker chooses which banner shows; the overview
 * backdrop underneath reuses a fixed standby recovery scenario so each variant is
 * judged against the surface it actually sits above.
 */
@Component({
  selector: 'showcase-banners',
  templateUrl: './showcase-banners.component.html',
  styleUrls: ['./showcase-banners.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseBannersComponent {
  readonly StatusContext = StatusContext
  readonly RECOVERY_SCREEN_TABS = RECOVERY_SCREEN_TABS

  readonly bannerScenarios: ReadonlyArray<BannerScenario> = buildBannerScenarios()
  bannerScenarioKey: string = this.bannerScenarios[0].key
  bannerPreviewDismissed = false

  private readonly recoveryScenarios: ReadonlyArray<RecoveryScreenScenario> = buildRecoveryScreenScenarios()

  get activeScenario(): BannerScenario {
    return this.bannerScenarios.find((s) => s.key === this.bannerScenarioKey) ?? this.bannerScenarios[0]
  }

  /** Fixed standby recovery scenario reused as the read-only overview backdrop. */
  get bgScenario(): RecoveryScreenScenario {
    return this.recoveryScenarios.find((s) => s.group === 'STANDBY') ?? this.recoveryScenarios[0]
  }

  setBannerScenario(key: string): void {
    if (this.bannerScenarioKey === key) return
    this.bannerScenarioKey = key
    this.bannerPreviewDismissed = false
  }

  dismissBannerPreview(): void {
    this.bannerPreviewDismissed = true
  }
}
